export interface ArticleContent {
  id: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  readTime: string;
  publishDate: string;
  views: string;
  expert: string;
  expertTitle: string;
  content: string;
  faqs?: { question: string; answer: string }[];
  relatedArticles: string[];
}

export const articleDetailData: Record<string, ArticleContent> = {
  'zhengchang-aiye-yanse': {
    id: 'zhengchang-aiye-yanse',
    title: '正常爱液的颜色有哪些？从透明到乳白的科学解读',
    excerpt: '很多女性对分泌物的颜色变化感到困惑。透明、白色、淡黄，哪些是正常的？本文从生理学角度为你全面解读。',
    coverImage: 'https://readdy.ai/api/search-image?query=Soft%20watercolor%20gradient%20from%20clear%20to%20milky%20white%20in%20abstract%20style%2C%20warm%20peach%20undertone%2C%20minimalist%20medical%20illustration%2C%20gentle%20texture%2C%20feminine%20health%20concept&width=800&height=450&seq=article-detail-01&orientation=landscape',
    category: '健康判断',
    categorySlug: 'jiankang-panduan',
    readTime: '6分钟',
    publishDate: '2026-07-28',
    views: '25.3万',
    expert: '张敏',
    expertTitle: '三甲医院妇科主任医师',
    content: `<p>女性的阴道分泌物（俗称"爱液"或"白带"）是反映生殖系统健康状况的重要指标之一。很多女性在看到内裤上有分泌物时会产生各种疑虑：这个颜色正常吗？为什么有时候是透明的，有时候又是白色的？今天，我们就从生理学角度全面解读正常爱液的颜色变化。</p>
<h4>一、透明色爱液——最常见的正常状态</h4>
<p>透明色的分泌物是最常见也是最典型的正常状态。这种透明、类似蛋清样的分泌物通常在排卵期前后出现，质地较为粘稠，可以拉丝。它的主要功能是帮助精子在生殖道中存活和移动，为受孕创造有利条件。透明色爱液主要由宫颈粘液构成，含有水分、电解质和少量蛋白质。</p>
<p>一般来说，排卵期前后的透明拉丝状分泌物是雌激素水平升高的直接表现，属于完全正常的生理现象，无需任何处理。</p>
<h4>二、乳白色爱液——同样正常的常见形态</h4>
<p>乳白色或淡白色的分泌物在非排卵期较为常见，尤其是在月经周期的黄体期（排卵后到下次月经前）。这种白色分泌物通常质地较为粘稠或呈糊状，由阴道壁脱落的上皮细胞、少量白细胞和阴道正常菌群代谢产物构成。</p>
<p>如果没有伴随瘙痒、灼热感或异常气味，乳白色分泌物完全属于正常范畴。孕早期由于激素变化，乳白色分泌物也可能增多，这也是正常的。</p>
<h4>三、淡黄色爱液——需要分情况判断</h4>
<p>淡黄色或浅黄色的分泌物在日常生活中也经常出现。判断是否正常，需要结合以下因素：</p>
<p>如果淡黄色仅出现在内裤上，且是干燥后的颜色——这通常是因为分泌物在空气中氧化所致，属于正常现象。分泌物的原始颜色是透明或白色的，接触空气后发生氧化反应变黄，就像苹果切开后会变色一样。</p>
<p>如果淡黄色伴有轻微酸味但无其他不适——也属于正常，阴道正常菌群（乳酸杆菌）代谢产生的酸性物质可能导致颜色轻微变化。</p>
<p>但如果同时出现外阴瘙痒、灼热感或腥臭味，则需要警惕细菌性阴道病或滴虫感染，建议及时就医。</p>
<h4>四、需要警惕的异常颜色</h4>
<p>以下几种颜色的分泌物通常提示可能存在健康问题，需要引起重视：</p>
<p>黄绿色或绿色——常见于滴虫感染，通常伴有泡沫状、腥臭味和外阴瘙痒灼热感。</p>
<p>灰色——细菌性阴道病的典型表现，常伴有明显的鱼腥味，性交后气味加重。</p>
<p>豆腐渣样白色——念珠菌（霉菌）感染的典型表现，常伴有剧烈外阴瘙痒。</p>
<p>带血丝或棕色——在非月经期出现，需排除宫颈病变、子宫内膜问题等。</p>
<h4>五、影响爱液颜色的日常因素</h4>
<p>除了生理周期，以下日常因素也可能影响分泌物的颜色：饮食习惯（如食用大量辛辣食物可能导致分泌物颜色轻微加深）、药物影响（某些抗生素可能改变阴道菌群平衡）、衣物材质（不透气的化纤内裤可能导致局部环境改变）、精神压力（长期压力可能影响激素水平）。</p>
<h4>总结</h4>
<p>正常爱液的颜色范围其实很宽泛——从透明到乳白色都是正常的，淡黄色在没有伴随症状时也大多正常。关键在于了解自己的"基线"状态，当颜色、气味、质地或伴随症状发生明显异常变化时，及时就医是最明智的选择。</p>`,
    faqs: [
      { question: '爱液干燥后变黄是正常的吗？', answer: '是的，这是非常正常的现象。分泌物中的蛋白质和细胞成分在接触空气后发生氧化反应，导致颜色从透明或白色变为淡黄色。就像苹果切开后暴露在空气中会变色一样，这并不意味着有问题。' },
      { question: '排卵期的透明拉丝状分泌物要持续几天？', answer: '通常持续2-4天，这是雌激素达到峰值时的正常表现。拉丝度最好的那几天是受孕概率最高的时期。如果持续时间超过一周且量特别大，建议咨询医生。' },
    ],
    relatedArticles: ['fenmi-jizhi-kepu', 'yuejing-zhouqi-fenmiwu', 'aiye-yichang-xinhao'],
  },
  'aiye-yuchanqi-bianhua': {
    id: 'aiye-yuchanqi-bianhua',
    title: '孕期爱液变化全记录：每个阶段需要注意什么',
    excerpt: '怀孕期间，女性分泌物会发生一系列变化。了解这些变化，有助于准妈妈们更好地监测自身和胎儿的健康状况。',
    coverImage: 'https://readdy.ai/api/search-image?query=Gentle%20abstract%20maternity%20concept%20in%20soft%20peach%20and%20cream%20tones%2C%20organic%20flowing%20shapes%2C%20warm%20natural%20light%2C%20minimalist%20composition%2C%20feminine%20wellness&width=800&height=450&seq=article-detail-02&orientation=landscape',
    category: '分泌机制',
    categorySlug: 'fenmi-jizhi',
    readTime: '10分钟',
    publishDate: '2026-07-25',
    views: '19.8万',
    expert: '李雪',
    expertTitle: '三甲医院产科副主任医师',
    content: '<p>孕期是女性一生中生理变化最为剧烈的阶段之一，阴道分泌物（爱液）也会随之发生一系列变化。了解这些变化的规律，对准妈妈们来说非常重要。</p><h4>孕早期（1-12周）</h4><p>怀孕初期，由于体内雌激素和孕激素水平的急剧升高，很多准妈妈会发现分泌物明显增多，通常呈乳白色或淡白色，质地较为粘稠。这是正常的生理反应——增加的分泌物有助于形成宫颈粘液栓，保护子宫内环境不受外界细菌侵扰。</p><h4>孕中期（13-27周）</h4><p>进入孕中期，分泌物通常维持在较高水平，颜色以乳白或淡黄为主。这个阶段胎盘已经形成并开始大量分泌激素，阴道壁的血流量也明显增加。准妈妈们需要注意的是保持外阴清洁干燥，穿透气性好的棉质内裤。</p><h4>孕晚期（28周-分娩）</h4><p>孕晚期分泌物可能进一步增多，有些准妈妈甚至会感觉"总是湿湿的"。临近预产期时，如果出现大量水样分泌物，需要警惕是否为羊水破裂（胎膜早破），应及时就医确认。</p><h4>需要警惕的异常信号</h4><p>整个孕期，如果分泌物出现以下变化，建议尽快就医：黄绿色伴腥臭味（警惕感染）、豆腐渣样伴瘙痒（警惕霉菌感染）、大量水样液体流出（警惕胎膜早破）、带血丝或褐色分泌物（需排除前置胎盘等问题）。</p>',
  },
  'sichu-qingjie-wuqu': {
    id: 'sichu-qingjie-wuqu',
    title: '私处清洁五大误区，90%的女性都中招了',
    excerpt: '使用洗液、频繁冲洗、香味护垫……这些看似"卫生"的习惯，可能正在伤害你的私密健康。专家告诉你正确的护理方法。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20bathroom%20product%20photography%20in%20warm%20beige%20tones%2C%20organic%20cotton%20textures%2C%20soft%20natural%20lighting%2C%20spa-like%20atmosphere%2C%20feminine%20self-care%20concept&width=800&height=450&seq=article-detail-03&orientation=landscape',
    category: '日常护理',
    categorySlug: 'richang-huli',
    readTime: '7分钟',
    publishDate: '2026-07-22',
    views: '32.1万',
    expert: '陈玲',
    expertTitle: '三甲医院妇科主治医师',
    content: '<p>很多女性在私处清洁方面存在各种认知误区。过度清洁不仅不能保持健康，反而会破坏阴道天然的微生态平衡，增加感染风险。</p><h4>误区一：每天使用妇科洗液</h4><p>健康女性的阴道有自洁功能，每天用清水清洗外阴就足够了。频繁使用妇科洗液会杀死阴道内的有益菌（乳酸杆菌），破坏正常的弱酸性环境，反而让致病菌有机可乘。</p><h4>误区二：进行阴道内冲洗</h4><p>除非医生明确建议，否则千万不要进行阴道内冲洗。这会将外部细菌带入阴道深处，同时冲走保护性的宫颈粘液和有益菌群，显著增加盆腔炎、宫外孕等风险。</p><h4>误区三：使用香味护垫保持"清新"</h4><p>香味护垫中的化学香料和添加剂可能导致外阴过敏和刺激。长期使用不透气的护垫还会造成局部湿热环境，成为细菌和真菌滋生的温床。</p><h4>误区四：如厕后从后往前擦拭</h4><p>正确的做法是从前往后（从尿道口向肛门方向）擦拭，这样可以避免将肛门区域的细菌带到尿道口和阴道口，减少尿路感染和阴道感染的风险。</p><h4>误区五：经期不洗澡或不换内裤</h4><p>经期更应注意卫生，每天淋浴、更换内裤和卫生用品。卫生巾建议每3-4小时更换一次，卫生棉条不超过8小时。</p>',
  },
  'yuejing-zhouqi-fenmiwu': {
    id: 'yuejing-zhouqi-fenmiwu',
    title: '月经周期与分泌物变化：一份完整的对照表',
    excerpt: '从月经期到排卵期再到黄体期，分泌物在每个月都有规律可循。掌握这个规律，你就是自己最好的健康管家。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20cyclical%20pattern%20in%20soft%20coral%20and%20cream%20tones%2C%20flowing%20circular%20design%2C%20minimalist%20medical%20illustration%2C%20warm%20gentle%20lighting%2C%20feminine%20health%20cycle%20concept&width=800&height=450&seq=article-detail-04&orientation=landscape',
    category: '分泌机制',
    categorySlug: 'fenmi-jizhi',
    readTime: '8分钟',
    publishDate: '2026-07-20',
    views: '28.6万',
    expert: '李雪',
    expertTitle: '三甲医院妇科副主任医师',
    content: '<p>女性月经周期中的分泌物变化是有规律可循的。掌握这个规律，就像拥有了一份身体的"晴雨表"。</p><h4>月经期（第1-5天）</h4><p>月经血为主，分泌物较少。经血量从多到少，颜色从鲜红到暗红再到棕色。</p><h4>卵泡期/排卵前（第6-13天）</h4><p>月经刚结束的几天，分泌物很少，感觉比较干爽。随着卵泡发育，雌激素逐渐升高，分泌物开始增多，从粘稠糊状逐渐变得稀薄。</p><h4>排卵期（第14天左右）</h4><p>分泌物量达到峰值，呈透明蛋清状，拉丝度极好（可拉至10cm以上）。这是雌激素峰值的结果，也是受孕能力最强的时期。</p><h4>黄体期/排卵后（第15-28天）</h4><p>排卵后，孕激素升高占主导，分泌物量减少，质地变粘稠，颜色从透明变为乳白色或淡黄色。到月经来潮前，分泌物可能再次略有增多。</p>',
  },
  'nianling-fenmiwu-bianhua': {
    id: 'nianling-fenmiwu-bianhua',
    title: '不同年龄段的分泌物特征：从青春期到更年期',
    excerpt: '20岁、30岁、40岁、50岁……每个年龄段的女性分泌物都有不同特点。了解这些变化，帮助你从容应对人生各阶段。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20concept%20in%20warm%20terracotta%20and%20cream%20tones%2C%20flowing%20organic%20shapes%20showing%20progression%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20feminine%20life%20stages&width=800&height=450&seq=article-detail-05&orientation=landscape',
    category: '生殖健康',
    categorySlug: 'shengzhi-jiankang',
    readTime: '9分钟',
    publishDate: '2026-07-18',
    views: '16.4万',
    expert: '王芳',
    expertTitle: '三甲医院妇科主任医师',
    content: '<p>女性从青春期到更年期，生殖系统经历持续的变化，分泌物特征也随之不同。</p><h4>青春期（12-18岁）</h4><p>月经初潮后的几年内，激素轴尚未完全成熟，分泌物可能不太规律。量、质地变化较大，有些女孩可能几乎没有分泌物，有些则较多——都是正常的。</p><h4>育龄期（20-35岁）</h4><p>这是生殖系统功能最旺盛的时期，激素水平稳定，分泌物呈现典型的周期变化。这个阶段的女性最能感受到排卵期的透明拉丝状分泌物。</p><h4>中年期（36-45岁）</h4><p>随着卵巢功能开始缓慢下降，分泌物总量可能略微减少，但周期规律通常仍然存在。这个阶段需要注意定期妇科检查。</p><h4>围绝经期和更年期（45岁+）</h4><p>雌激素水平显著下降导致分泌物明显减少，很多女性会感到阴道干涩。这是正常的生理变化，但如果严重影响生活质量，可以咨询医生寻求缓解方案。</p>',
  },
  'aiye-yichang-xinhao': {
    id: 'aiye-yichang-xinhao',
    title: '这些分泌物异常信号，可能提示妇科问题',
    excerpt: '豆腐渣样、黄绿色、带血丝……不同异常表现对应不同的健康问题。学会识别这些信号，及时就医很重要。',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20medical%20alert%20concept%20in%20soft%20coral%20and%20ivory%20tones%2C%20minimalist%20warning%20pattern%2C%20clean%20composition%2C%20warm%20lighting%2C%20feminine%20health%20awareness%20concept&width=800&height=450&seq=article-detail-06&orientation=landscape',
    category: '健康判断',
    categorySlug: 'jiankang-panduan',
    readTime: '11分钟',
    publishDate: '2026-07-15',
    views: '35.7万',
    expert: '张敏',
    expertTitle: '三甲医院妇科主任医师',
    content: '<p>学会识别分泌物的异常信号，对于女性健康至关重要。</p><h4>豆腐渣样分泌物</h4><p>白色、稠厚、呈凝乳状或豆腐渣样，通常伴有剧烈外阴瘙痒和灼痛。这是念珠菌性阴道炎（霉菌感染）的典型表现。常见诱因包括：近期使用抗生素、怀孕、糖尿病控制不佳、免疫力下降等。</p><h4>黄绿色泡沫状分泌物</h4><p>黄绿色、稀薄泡沫状、量多、有明显腥臭味，常伴有外阴瘙痒和尿频尿痛。这是滴虫性阴道炎的典型表现，属于性传播疾病，需要夫妻双方同时治疗。</p><h4>灰色均质分泌物</h4><p>灰白色、稀薄、均匀附着在阴道壁上，有明显的鱼腥味（性交后加重）。这是细菌性阴道病的典型表现，是由于阴道菌群失调，厌氧菌过度生长所致。虽然不是严格的性传播疾病，但性活跃期女性更常见。</p><h4>血性分泌物</h4><p>在非月经期出现带血丝的分泌物，需要根据年龄和具体情况判断：排卵期少量出血可能正常；但如果持续或反复出现，需排除宫颈息肉、宫颈糜烂、子宫内膜病变甚至宫颈癌等可能。</p>',
  },
  'shiyong-zhinan': {
    id: 'shiyong-zhinan',
    title: '爱液视频平台使用指南',
    excerpt: '了解如何更好地使用爱液视频平台，找到你需要的科普内容。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20digital%20interface%20in%20warm%20peach%20and%20cream%20tones%2C%20minimalist%20app%20design%2C%20soft%20lighting%2C%20user-friendly%20technology%20concept&width=800&height=450&seq=article-guide&orientation=landscape',
    category: '平台指南',
    categorySlug: 'shiyong-zhinan',
    readTime: '3分钟',
    publishDate: '2026-06-01',
    views: '5.2万',
    expert: '爱液视频团队',
    expertTitle: '平台运营团队',
    content: '<p>欢迎来到爱液视频！以下是平台的简单使用指南。</p><h4>浏览视频</h4><p>在首页你可以看到推荐视频和热门文章，点击即可观看。你也可以通过顶部导航栏进入不同的分类页面，按类别浏览内容。</p><h4>搜索功能</h4><p>点击导航栏的搜索按钮，输入你感兴趣的关键词，即可找到相关科普视频和文章。</p><h4>分类浏览</h4><p>我们提供爱液成分、分泌机制、健康判断、日常护理、生殖健康、性教育六大分类，帮助你快速定位所需内容。</p>',
  },
  'neirong-shengming': {
    id: 'neirong-shengming',
    title: '内容免责声明',
    excerpt: '爱液视频平台内容声明与免责条款。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20legal%20document%20concept%20in%20warm%20cream%20tones%2C%20minimalist%20design%2C%20soft%20lighting%2C%20professional%20atmosphere&width=800&height=450&seq=article-disclaimer&orientation=landscape',
    category: '平台指南',
    categorySlug: 'shiyong-zhinan',
    readTime: '2分钟',
    publishDate: '2026-06-01',
    views: '3.1万',
    expert: '爱液视频团队',
    expertTitle: '平台运营团队',
    content: '<p>爱液视频平台所有科普内容仅供健康知识传播之用，不构成医疗诊断或治疗建议。如您有任何健康问题，请及时咨询专业医疗机构和执业医师。平台内容经过专业审核，但由于医学知识的不断更新，我们不对内容的绝对完整性和时效性做出保证。观看本平台内容不应替代专业的医疗咨询、诊断或治疗。</p>',
  },
};